import {Component, Input} from '@angular/core';

@Component({
    selector: 'tab',
    styles: [`
        .pane {
            padding: 1em;
        }
    `],
    template: `
        <div [hidden]="!active" class="pane">
            <ng-content>
            </ng-content>
        </div>
    `
})
export class Tab {
    @Input('tabTitle') title: string;
    @Input() active = false;
}


// WEBPACK FOOTER //
// ./public/app/common/tabs/tab/tab.component.ts